<!--
    理论考试
    需要拿到异步数据之后再调用该组件
-->
<template>
    <div class="m-paper m-paperExam" :class="{'m-paperGraphic': isGraphic}">

        <header class="paper-header">
            <div class="paper-title">
                <img src="../../assets/images/common/nav_logo.png" alt="">
                <h1>{{paper.title}}</h1>
                <el-button @click="closeFn" type="danger" size="small" round><i class="nucfont inuc-close"></i>
                </el-button>
            </div>
            <div class="paper-info">
                <ul>
                    <li>
                        <h5>{{$t('exam.totalCount')}}</h5>
                        <p><b>{{topics.length}}</b> {{$t('exam.question')}}</p>
                    </li>
                    <li>
                        <h5>{{$t('paper.totalScore')}}</h5>
                        <p><b>{{paper.totalScore}}</b> {{$t('paper.points')}}</p>
                    </li>
                    <li>
                        <h5>{{$t('count.passScore')}}</h5>
                        <p><b>{{paper.passScore}}</b> {{$t('paper.points')}}</p>
                    </li>
                    <li>
                        <h5>{{$t('exam.period')}}</h5>
                        <p><b>{{Math.floor(examData.totalSeconds / 60)}}</b> {{$t('exam.min')}}</p>
                    </li>
                    <li class="switch-mode" v-if="!isGraphic">
                        <el-radio-group v-model="multiMode" size="medium">
                            <el-radio-button :label="true">{{$t('exam.multiMode')}}</el-radio-button>
                            <el-radio-button :label="false">{{$t('exam.singleMode')}}</el-radio-button>
                        </el-radio-group>
                    </li>
                </ul>
                <div class="clock">
                    <i class="nucfont inuc-clock"></i>
                    <span class="left-time">{{$t('exam.loading')}}</span>
                </div>
            </div>
        </header>

        <div class="paper-container">
            <div class="paper-main" v-if="topics.length">

                <aside class="paper-aside">
                    <div class="paper-aside-inner">

                        <exam-camera
                            v-if="examData.isMonitor && !resultDialog"
                            :data="examData"
                            @status-change="cameraStatusChange"
                        />

                        <div class="aside-box">
                            <h2 class="box-header">{{$t('exam.answerSheet')}}</h2>
                            <div class="status-desc">
                                <p><span class="done"></span>{{$t('exam.answered')}}</p>
                                <p><span class="undone"></span>{{$t('exam.blank')}}</p>
                            </div>
                            <div class="box-sheet">
                                <div class="sheet-list-wrap" v-for="(obj, key) in multiTopic" v-if="obj.length">
                                    <h3> {{[$t('paper.single'), $t('paper.multiple'), $t('paper.trueOrFalse'), $t('paper.matching'), '快速判断', '位置标记', '位置标记及类型选择'][key - 1]}}</h3>
                                    <ul class="sheet-list">
                                        <li v-for="item in obj"
                                            :class="[{'active' : item.index+1 === number}, sheetStatus(item.topic.id)]"
                                            @click="toNumber(item.index+1)">{{item.index+1}}
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div class="btn-submit">
                                <el-button @click="toSubmit" type="primary">{{$t('exam.submit')}}</el-button>
                            </div>
                        </div>
                    </div>
                </aside>

                <div class="paper-left" v-if="canAnswer">
                    <div v-if="multiMode" class="paper-list-container mode-multi">
                        <section class="paper-list" v-for="(obj, key) in multiTopic" v-if="obj.length" :key="key">
                            <h2 class="box-header">
                                {{[$t('paper.single'), $t('paper.multiple'), $t('paper.trueOrFalse'), $t('paper.matching')][key - 1]}}
                                （{{[paper.singleScore, paper.multipleScore, paper.tfScore, paper.pairScore][key - 1]}}{{$t('paper.points')}}）</h2>
                            <!-- 题目开始 -->
                            <div class="paper-item" v-for="(item, index) in obj" :key="index" :index="item.index">
                                <div class="detail">
                                    <!-- 题干 -->
                                    <div class="topic-title">
                                        <span class="no">{{item.index + 1}}.</span>
                                        <!--<span class="type">【{{[$t('paper.single'), $t('paper.multiple'), $t('paper.trueOrFalse')][item.topic.type - 1]}}】</span>-->
                                        <span class="titleRT" v-html="item.topic.titleRT"></span>
                                    </div>

                                    <!-- 选项 -->
                                    <div>
                                        <el-radio-group v-if="item.topic.type === 1" v-model="response[item.topic.id]"
                                                        @change="radioChange">
                                            <el-radio class="topic-choice"
                                                      v-for="v in item.topic.options"
                                                      @click.native="multiRadioClick"
                                                      :label="v.id" :key="v.id">
                                                <em>{{v.tagName}}.</em>
                                                <div class="options" v-html="v.titleRT"></div>
                                            </el-radio>
                                        </el-radio-group>

                                        <template v-if="item.topic.type === 2">
                                            <el-checkbox-group v-model="response[item.topic.id]" @change="checkboxChange">
                                                <el-checkbox class="topic-choice" v-for="v in item.topic.options"
                                                             :label="v.id"
                                                             :key="v.id">
                                                    <em>{{v.tagName}}.</em>
                                                    <div class="options" v-html="v.titleRT"></div>
                                                </el-checkbox>
                                            </el-checkbox-group>
                                        </template>

                                        <el-radio-group v-if="item.topic.type === 3" v-model="response[item.topic.id]"
                                                        @change="radioChange">
                                            <el-radio class="topic-choice"
                                                      v-for="v in item.topic.options"
                                                      @click.native="multiRadioClick"
                                                      :label="v.id" :key="v.id">
                                                <em>{{v.tagName}}</em>
                                            </el-radio>
                                        </el-radio-group>
                                    </div>

                                    <div class="match-topic" v-if="item.topic.type == 4"  v-viewer="{movable: false}">
                                        <div class="match-wrap">
                                            <div class="image">
                                                <img :src="item.topic.picViewUrl ? item.topic.picViewUrl : ''" alt="">
                                            </div>

                                        </div>
                                        <div class="match-drag-area">
                                            <div class="drop-area">
                                                <div class="drop-item">
                                                    <label class="item-tag">A.</label>
                                                    <draggable class="drop-group" :class="{'selected':item.topic.dropList1.length>0}"
                                                               element="div"
                                                               v-model="item.topic.dropList1"
                                                               :options="{group: { name: 'm'+item.topic.id,pull: false},sort: false}"
                                                               :disabled="flag(item.topic.dropList1)"
                                                    >

                                                        <div v-if="item.topic.dropList1.length>0">
                                                            <span class="item-name">{{getItem(item.topic.dropList1)}}</span>
                                                        </div>
                                                    </draggable>
                                                    <p class="item-delete">
                                                        <span v-if="item.topic.dropList1.length>0" class="nucfont inuc-incorrect" @click="deleteItem(1,item.topic)"></span>
                                                    </p>
                                                </div>
                                                <div class="drop-item">
                                                    <label class="item-tag">B.</label>
                                                    <draggable class="drop-group" :class="{'selected':item.topic.dropList2.length>0}"
                                                               element="div"
                                                               v-model="item.topic.dropList2"
                                                               :options="{group: { name: 'm'+item.topic.id,pull: false},sort: false}"
                                                               :disabled="flag(item.topic.dropList2)"
                                                    >
                                                        <div v-if="item.topic.dropList2.length>0">
                                                            <span class="item-name">{{getItem(item.topic.dropList2)}}</span>
                                                        </div>

                                                    </draggable>
                                                    <p class="item-delete">
                                                        <span v-if="item.topic.dropList2.length>0" class="nucfont inuc-incorrect" @click="deleteItem(2,item.topic)"></span>
                                                    </p>
                                                </div>
                                                <div class="drop-item" v-if="item.topic.rectangleOptions.length>2">
                                                    <label class="item-tag">C.</label>
                                                    <draggable class="drop-group" :class="{'selected':item.topic.dropList3.length>0}"
                                                               element="div"
                                                               v-model="item.topic.dropList3"
                                                               :options="{group: { name: 'm'+item.topic.id,pull: false},sort: false}"
                                                               :disabled="flag(item.topic.dropList3)"
                                                    >
                                                        <div v-if="item.topic.dropList3.length>0">
                                                            <span class="item-name">{{getItem(item.topic.dropList3)}}</span>
                                                        </div>
                                                    </draggable>
                                                    <p class="item-delete">
                                                        <span v-if="item.topic.dropList3.length>0" class="nucfont inuc-incorrect" @click="deleteItem(3,item.topic)"></span>
                                                    </p>
                                                </div>
                                                <div class="drop-item" v-if="item.topic.rectangleOptions.length >3">
                                                    <label class="item-tag">D.</label>
                                                    <draggable class="drop-group" :class="{'selected':item.topic.dropList4.length>0}"
                                                               element="div"
                                                               v-model="item.topic.dropList4"
                                                               :options="{group: { name: 'm'+item.topic.id,pull: false},sort: false}"
                                                               :disabled="flag(item.topic.dropList4)"
                                                    >
                                                        <div v-if="item.topic.dropList4.length>0">
                                                            <span class="item-name">{{getItem(item.topic.dropList4)}}</span>
                                                        </div>
                                                    </draggable>
                                                    <p class="item-delete">
                                                        <span v-if="item.topic.dropList4.length>0" class="nucfont inuc-incorrect" @click="deleteItem(4,item.topic)"></span>
                                                    </p>
                                                </div>
                                            </div>
                                            <draggable class="list-group"
                                                       element="div"
                                                       v-model="item.topic.pairOptions"
                                                       :options="{group: { name: 'm'+item.topic.id,put: false},ghostClass: 'ghost',sort: false}"
                                                       :move="onMove"
                                                       @end="onEnd">
                                                <div class="drag-item" v-for="(itm,idx) in item.topic.pairOptions" :key="'md'+idx">
                                                    {{itm.value}}
                                                </div>
                                            </draggable>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- 题目结束 -->
                        </section>
                    </div>

                    <section v-else class="paper-list-container mode-single">
                        <section class="paper-list">

                            <h2 class="box-header">
                                {{[$t('paper.single'), $t('paper.multiple'), $t('paper.trueOrFalse'), $t('paper.matching'), '快速判断', '位置标记', '位置标记及类型选择'][singleTopic.topic.type - 1]}}
                                （{{[paper.singleScore, paper.multipleScore, paper.tfScore, paper.pairScore, paper.graphicScore, paper.graphicScore, paper.graphicScore][singleTopic.topic.type - 1]}}{{$t('paper.points')}}）</h2>

                            <!-- 题目开始 -->

                            <!-- 图片题 -->
                            <paper-graphic
                                v-if="isGraphic"
                                :isExam="true"
                                :response.sync="response"
                            ></paper-graphic>

                            <!-- 普通理论题 -->
                            <div class="paper-item" v-else>
                                <div class="detail">
                                    <!-- 题干 -->
                                    <div class="topic-title">
                                        <span class="no">{{number}}.</span>
                                        <!--<span class="type">【{{[$t('paper.single'), $t('paper.multiple'), $t('paper.trueOrFalse')][singleTopic.topic.type - 1]}}】</span>-->
                                        <span class="titleRT" v-html="singleTopic.topic.titleRT"></span>
                                    </div>

                                    <!-- 选项 -->
                                    <div>
                                        <el-radio-group v-if="singleTopic.topic.type === 1"
                                                        v-model="response[singleTopic.topic.id]"
                                                        @change="radioChange">
                                            <el-radio class="topic-choice" v-for="v in singleTopic.topic.options"
                                                      :label="v.id"
                                                      :key="v.id">
                                                <em>{{v.tagName}}.</em>
                                                <div class="options" v-html="v.titleRT"></div>
                                            </el-radio>
                                        </el-radio-group>

                                        <template v-if="singleTopic.topic.type === 2">
                                            <el-checkbox-group v-model="response[singleTopic.topic.id]">
                                                <el-checkbox class="topic-choice" v-for="v in singleTopic.topic.options"
                                                             :label="v.id"
                                                             :key="v.id" @change="checkboxChange">
                                                    <em>{{v.tagName}}.</em>
                                                    <div class="options" v-html="v.titleRT"></div>
                                                </el-checkbox>
                                            </el-checkbox-group>
                                        </template>

                                        <el-radio-group v-if="singleTopic.topic.type === 3"
                                                        v-model="response[singleTopic.topic.id]"
                                                        @change="radioChange">
                                            <el-radio class="topic-choice" v-for="v in singleTopic.topic.options"
                                                      :label="v.id"
                                                      :key="v.id">
                                                <em>{{v.tagName}}</em>
                                            </el-radio>
                                        </el-radio-group>
                                    </div>
                                    <div class="match-topic" v-if="singleTopic.topic.type == 4"  v-viewer="{movable: false}">
                                        <div class="match-wrap">
                                            <div class="image">
                                                <img :src="singleTopic.topic.picViewUrl ? singleTopic.topic.picViewUrl : ''" alt="">
                                            </div>
                                        </div>
                                        <div class="match-drag-area">
                                            <div class="drop-area">
                                                <div class="drop-item">
                                                    <label class="item-tag">A.</label>
                                                    <draggable class="drop-group" :class="{'selected':singleTopic.topic.dropList1.length>0}"
                                                               element="div"
                                                               v-model="singleTopic.topic.dropList1"
                                                               :options="{group: { name: 'm'+singleTopic.topic.id,pull: false},sort: false}"
                                                               :disabled="flag(singleTopic.topic.dropList1)"
                                                    >

                                                        <div v-if="singleTopic.topic.dropList1.length>0">
                                                            <span class="item-name">{{getItem(singleTopic.topic.dropList1)}}</span>
                                                        </div>
                                                    </draggable>
                                                    <p class="item-delete">
                                                        <span v-if="singleTopic.topic.dropList1.length>0" class="nucfont inuc-incorrect" @click="deleteItem(1,singleTopic.topic)"></span>
                                                    </p>
                                                </div>
                                                <div class="drop-item">
                                                    <label class="item-tag">B.</label>
                                                    <draggable class="drop-group" :class="{'selected':singleTopic.topic.dropList2.length>0}"
                                                               element="div"
                                                               v-model="singleTopic.topic.dropList2"
                                                               :options="{group: { name: 'm'+singleTopic.topic.id,pull: false},sort: false}"
                                                               :disabled="flag(singleTopic.topic.dropList2)"
                                                    >
                                                        <div v-if="singleTopic.topic.dropList2.length>0">
                                                            <span class="item-name">{{getItem(singleTopic.topic.dropList2)}}</span>
                                                        </div>

                                                    </draggable>
                                                    <p class="item-delete">
                                                        <span v-if="singleTopic.topic.dropList2.length>0" class="nucfont inuc-incorrect" @click="deleteItem(2,singleTopic.topic)"></span>
                                                    </p>
                                                </div>
                                                <div class="drop-item" v-if="singleTopic.topic.rectangleOptions.length>2">
                                                    <label class="item-tag">C.</label>
                                                    <draggable class="drop-group" :class="{'selected':singleTopic.topic.dropList3.length>0}"
                                                               element="div"
                                                               v-model="singleTopic.topic.dropList3"
                                                               :options="{group: { name: 'm'+singleTopic.topic.id,pull: false},sort: false}"
                                                               :disabled="flag(singleTopic.topic.dropList3)"
                                                    >
                                                        <div v-if="singleTopic.topic.dropList3.length>0">
                                                            <span class="item-name">{{getItem(singleTopic.topic.dropList3)}}</span>
                                                        </div>
                                                    </draggable>
                                                    <p class="item-delete">
                                                        <span v-if="singleTopic.topic.dropList3.length>0" class="nucfont inuc-incorrect" @click="deleteItem(3,singleTopic.topic)"></span>
                                                    </p>
                                                </div>
                                                <div class="drop-item" v-if="singleTopic.topic.rectangleOptions.length >3">
                                                    <label class="item-tag">D.</label>
                                                    <draggable class="drop-group" :class="{'selected':singleTopic.topic.dropList4.length>0}"
                                                               element="div"
                                                               v-model="singleTopic.topic.dropList4"
                                                               :options="{group: { name: 'm'+singleTopic.topic.id,pull: false},sort: false}"
                                                               :disabled="flag(singleTopic.topic.dropList4)"
                                                    >
                                                        <div v-if="singleTopic.topic.dropList4.length>0">
                                                            <span class="item-name">{{getItem(singleTopic.topic.dropList4)}}</span>
                                                        </div>
                                                    </draggable>
                                                    <p class="item-delete">
                                                        <span v-if="singleTopic.topic.dropList4.length>0" class="nucfont inuc-incorrect" @click="deleteItem(4,singleTopic.topic)"></span>
                                                    </p>
                                                </div>
                                            </div>
                                            <draggable class="list-group"
                                                       element="div"
                                                       v-model="singleTopic.topic.pairOptions"
                                                       :options="{group: { name: 'm'+singleTopic.topic.id,put: false},ghostClass: 'ghost',sort: false}"
                                                       :move="onMove"
                                                       @end="onEnd">
                                                <div class="drag-item" v-for="(itm,idx) in singleTopic.topic.pairOptions" :key="'md'+idx">
                                                    {{itm.value}}
                                                </div>
                                            </draggable>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </section>
                        <!-- 题目结束 -->

                        <div class="button-group">
                            <el-button @click="lastOne" :disabled="number === 1">{{$t('exam.prev')}}
                            </el-button>
                            <el-button @click="nextOne" :disabled="number === topics.length">
                                {{$t('exam.next')}}
                            </el-button>
                        </div>
                    </section>
                </div>

                <div v-else class="paper-avoid-container">
                    <div class="avoid-camera">
                        <div class="title">
                            <i class="el-icon-warning"></i>开启摄像头后方可答题
                        </div>
                        <div class="result">
                            <p><b class="error-dot"></b>{{camera.errorText}}</p>
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <el-dialog
            :title="$t('exam.result')"
            class="result-dialog"
            :visible.sync="resultDialog"
            width="600px"
            :modal-append-to-body="false"
            :close-on-click-modal="false"
            :show-close="false">
            <div class="container">
                <p class="score">{{resultData.score}} {{$t('paper.points')}}</p>
                <div class="result">
                    <img v-if="resultData.isPass" src="~@/assets/images/student/exam_pass.png" alt="pass">
                    <img v-else src="~@/assets/images/student/exam_unpass.png" alt="not pass">
                    <p class="status" :class="resultData.isPass ? 'pass':'unpass' ">
                        {{resultData.isPass ? '恭喜你，通过考试！' : '很遗憾，你未通过考试！'}}
                    </p>
                </div>
                <div class="info-wrap">
                    <p class="info">
                        <span class="title">考试题目：</span>
                        <span class="content">{{paper.title}}</span>
                    </p>
                    <p class="info">
                        <span class="title">总分：</span>
                        <span class="content">{{paper.totalScore}} 分</span>
                    </p>
                    <p class="info">
                        <span class="title">及格分：</span>
                        <span class="content">{{paper.passScore}} 分</span>
                    </p>
                    <p class="info">
                        <span class="title">正确：</span>
                        <span class="content">{{resultData.correct}} 题</span>
                    </p>
                    <p class="info">
                        <span class="title">错误：</span>
                        <span class="content">{{resultData.wrong}} 题</span>
                    </p>
                    <p class="info">
                        <span class="title">正确率：</span>
                        <span class="content">{{ ((resultData.correct/topics.length)*100).toFixed(1) }}%</span>
                    </p>
                    <p class="info other">
                        于 {{resultData.submitTime}} 提交作答
                    </p>

                    <div class="btn-group">
                        <el-button @click="afterCloseResult(false)" v-if="resultData.allowReview === false" size="medium">返回</el-button>
                        <el-button @click="afterCloseResult(true)"  v-else type="primary" size="medium">查看考卷</el-button>
                    </div>
                </div>
            </div>
        </el-dialog>

    </div>
</template>

<script>
    import api from '@/api';
    import {CountDown, Storage, screenfull} from '@/utils';
    import draggable from 'vuedraggable'
    import PaperGraphic from "./PaperGraphic";
    import ExamCamera from "./ExamCamera";

    export default {
        components: {
            draggable,
            PaperGraphic,
            ExamCamera
        },

        props: {
            // 试卷总数据
            examData: {
                required: true,
            },
            // 是否为模拟考试，默认false
            isMock: {
                type: Boolean,
                default: false
            },
            // 是否是一个新的补考试卷，是的话不取本地缓存数据
            isResitPaperClean: {
                type: Boolean,
                default: false
            },
        },
        data() {
            let response = {};
            this.examData.records.forEach(item => {
                response[item.topicID] = item.answer;
            });

            return {
                number: 1,             //当前的题号
                multiMode: true,
                singleTopic: null,
                multiTopic: null,
                response: response,
                resultDialog: false,
                resultData: {},
                isGraphic: false,     // 是否为图片题
                camera: {
                    opened: null,
                    errorText: ''
                }
            }
        },
        created() {
            console.log(this.examData)

            /**** 处理数据 ****/
            let topics = this.examData.paper.relationship
            topics.forEach(item => {
                if(item.topic.type==4){
                    item.topic.dropList1 = []
                    item.topic.dropList2 = []
                    item.topic.dropList3 = []
                    item.topic.dropList4 = []
                }
                if (item.topic.type === 7) {
                    if (item.topic.pattern===1) {
                        item.topic.type = 5
                    } else if (item.topic.pattern===2) {
                        item.topic.type = 6
                    } else if (item.topic.pattern===3) {
                        item.topic.type = 7
                    }
                }
            });

            // 对图片题进行分类排序
            this.isGraphic = this.examData.paper.method === 5
            if (this.isGraphic) {
                this.multiMode = false
                topics.sort((a, b) => a.topic.type - b.topic.type)
            }

            /**** 加载本地数据 ****/
            // 如果是考试并且有本地数据，则取本地数据
            if (!this.isMock) {
                this.localKey = `exam_${this.examData.testID}`;

                let localResponse = Storage.get(this.localKey);

                if (localResponse) {
                    if (!this.isResitPaperClean) {
                        this.response = localResponse;
                        this.examData.paper.relationship.forEach(itm => {
                            for (let id in this.response) {
                                if(id == itm.topicID && itm.topic.type==4){
                                    if(this.response[id].length>0){
                                        let answer = []
                                        this.response[id].forEach(ele => {
                                            itm.topic.pairOptions.forEach(opt =>{
                                                if(ele == opt.id){
                                                    answer.push(opt)
                                                }
                                            })
                                        })
                                        itm.topic.dropList1.push(answer[0])
                                        if(this.response[id].length>1){
                                            itm.topic.dropList2.push(answer[1])
                                        }
                                        if(this.response[id].length>2){
                                            itm.topic.dropList3.push(answer[2])
                                        }
                                        if(this.response[id].length>3){
                                            itm.topic.dropList4.push(answer[3])
                                        }
                                        itm.topic.pairOptions = []
                                    }
                                }
                            }
                        });
                    } else {
                        // 每次点击补考按钮，都是一个新的考卷
                        Storage.remove(this.localKey);
                    }
                }
            }

            this.savedTime = new Date().getTime();

            this.initCountDown();
        },
        mounted() {
            this.$scrollElement = $('.paper-container');

            this.initKeyboard()

            if (!this.isMock) {
                $(window).on('blur', () => {
                    api.examLeavetimes(this.examData.testID)
                })
            }
        },
        computed: {
            /**
             *  topics: 题目数据
             */
            topics() {
                let topic;

                topic = this.examData.paper.relationship;

                topic.forEach((item, index) => {
                    item.index = index;
                });

                this.singleTopic = topic[this.number - 1];
                this.multiTopic = {
                    1: topic.filter(item => item.topic.type === 1),
                    2: topic.filter(item => item.topic.type === 2),
                    3: topic.filter(item => item.topic.type === 3),
                    4: topic.filter(item => item.topic.type === 4),
                    5: topic.filter(item => item.topic.type === 5),
                    6: topic.filter(item => item.topic.type === 6),
                    7: topic.filter(item => item.topic.type === 7),
                };

                return topic;
            },
            paper() {
                return this.examData.paper;
            },

            // 考卷可否作答，目前只有需要监考且未开摄像头的情况下不能作答
            canAnswer() {
                const notOpenCamera = this.examData.isMonitor && this.camera.opened === false

                return !notOpenCamera
            }
        },
        methods: {
            onEnd(){
                this.savePaperOnLocal();
            },
            flag(data) {
                let flag = false
                if(data.length>0){
                    flag = true
                }
                return flag
            },
            getItem(data){
                if(data.length>0){
                    return data[0].value
                }
            },
            deleteItem(type, data) {
                let index = this.examData.paper.relationship.findIndex(v => v.topicID == data.id)
                switch (type) {
                    case 1:
                        this.examData.paper.relationship[index].topic.pairOptions.push(data.dropList1[0])
                        this.examData.paper.relationship[index].topic.dropList1 = []
                        break;
                    case 2:
                        this.examData.paper.relationship[index].topic.pairOptions.push(data.dropList2[0])
                        this.examData.paper.relationship[index].topic.dropList2 = []
                        break;
                    case 3:
                        this.examData.paper.relationship[index].topic.pairOptions.push(data.dropList3[0])
                        this.examData.paper.relationship[index].topic.dropList3 = []
                        break;
                    case 4:
                        this.examData.paper.relationship[index].topic.pairOptions.push(data.dropList4[0])
                        this.examData.paper.relationship[index].topic.dropList4 = []
                        break;
                }
                this.savePaperOnLocal()
            },
            radioChange(val) {
                this.savePaperOnLocal();
            },
            checkboxChange() {
                this.savePaperOnLocal();
            },
            initCountDown() {
                let duration = this.examData.remainSeconds;

                if (!duration) return

                // 多少秒存一次，默认30s
                const frequency = 30

                this.cd = new CountDown(duration*1000, (time) => {
                    time = time/1000;
                    let minute = Math.floor(time / 60);
                    let second = time % 60;

                    $('.left-time').text(`${minute} ${this.$t('count.min')} ${second} ${this.$t('count.s')}`);

                    // 定时保存用户数据到server
                    if (new Date().getTime() - this.savedTime >= frequency * 1000) {
                        this.savedTime = new Date().getTime();
                        this.savePaperOnServer();
                    }
                }, () => {
                    this.submitPaper();
                })

            },
            // 只有考试才会存储到本地
            savePaperOnLocal() {
                for (let id in this.response) {
                    this.examData.paper.relationship.forEach(itm => {
                        if(id == itm.topicID && itm.topic.type==4){
                            this.response[id] = []
                            let len = itm.topic.dropList1.length + itm.topic.dropList2.length +itm.topic.dropList3.length +itm.topic.dropList4.length
                            if(len == itm.topic.rectangleOptions.length){
                                this.response[id].push(itm.topic.dropList1[0].id)
                                if(itm.topic.dropList2.length>0){
                                    this.response[id].push(itm.topic.dropList2[0].id)
                                }
                                if(itm.topic.dropList3.length>0){
                                    this.response[id].push(itm.topic.dropList3[0].id)
                                }
                                if(itm.topic.dropList4.length>0){
                                    this.response[id].push(itm.topic.dropList4[0].id)
                                }
                            }
                        }
                    });
                }

                if (!this.isMock) {
                    Storage.set(this.localKey, this.response);
                }
            },
            savePaperOnServer() {
                let data = [];

                for (let id in this.response) {
                    data.push({
                        topicID: id,
                        answer: this.response[id],
                        result: false
                    })
                }

                if (!this.isMock) {
                    api.saveTheoryExam(this.examData.testID, data);
                } else {
                    api.saveTheoryMockExam(this.examData.testID, this.examData.guid, data);
                }

            },

            lastOne(){
                this.number > 1 && this.number--;
            },
            nextOne(){
                this.number < this.topics.length && this.number++;
            },
            toNumber(n) {
                this.number = n;

                if (this.multiMode) {
                    this.$scrollElement.scrollTop($("[index=" + (n-1) + "]").position().top - 15);
                }
            },
            // 多题模式下，点击单选和判断滑动到下一题
            multiRadioClick(e) {
                let thisIndex = ~~$(e.target).closest('.paper-item').attr('index');

                let isRepeat = thisIndex === 0 && this.number === 2 ||
                    thisIndex !== 0 && this.number === thisIndex + 1;
                let isLast = thisIndex === this.multiTopic[1].length - 1 ||
                    thisIndex >= this.topics.length - 1;

                // 防止重复触发事件、最后一题不处理
                if (isRepeat || isLast) {
                    return;
                }

                this.number = thisIndex + 1;

                let pos = $("[index=" + (thisIndex + 1) + "]").position().top - 30;
                this.$scrollElement.animate({scrollTop: pos}, 500);
            },
            sheetStatus(topicID) {
                let status = '';
                let topic = this.response[topicID];

                let singleHasContent = topic && typeof topic === 'number';
                let multiHasContent = Array.isArray(topic) && topic.length;
                let graphicHasContent = Object.prototype.toString.call(topic) === '[object Object]' && topic.isPass!==null

                if (singleHasContent || multiHasContent || graphicHasContent) {
                    status = 'check';
                }

                return status;
            },

            toSubmit() {
                let checkedNum = $('.sheet-list').find('.check').length;
                let leftNum = this.topics.length - checkedNum;
                let msg = leftNum > 0 ? this.$t('m.submitUndonePaper', [leftNum]) : this.$t('m.submitPaper');

                this.$confirm(msg, this.$t('m.tip'), {
                    type: 'warning'
                }).then(() => {
                    this.submitPaper();
                }).catch(() => {
                });
            },
            submitPaper() {
                let submitData = [];

                for (let id in this.response) {
                    submitData.push({
                        topicID: id,
                        answer: this.response[id],
                        result: false
                    })
                }

                if (!this.isMock) {
                    // 提交考试
                    api.submitTheoryExam(this.examData.testID, submitData)
                        .then(res => {
                            this.cd.clear()
                            Storage.remove(this.localKey);
                            return api.theoryExamAchievement(this.examData.testID);
                        })
                        .then(res => {
                            this.resultDialog = true;
                            this.resultData = res.package;
                        })

                } else {

                    // 提交模拟考试
                    api.submitTheoryMockExam(this.examData.testID, this.examData.guid, submitData)
                        .then(res => {
                            this.cd.clear()
                            this.examData.mockTestID = res.package;
                            return api.theoryMockExamAchievement(res.package);
                        })
                        .then(res => {
                            this.resultDialog = true;
                            this.resultData = res.package;
                        })
                }
            },

            // 摄像头变化
            cameraStatusChange(status, text) {
                this.camera.opened = status
                this.camera.errorText = text
            },

            initKeyboard() {
                $(document).on('keydown.paper', e => {
                    let key = e.keyCode
                    if (this.multiMode) return
                    if (key === 37) {
                        this.lastOne()
                    }
                    if (key === 39) {
                        this.nextOne()
                    }
                })
            },

            closeFn(){
                screenfull.exit();
                this.cd && this.cd.clear()
                this.$emit('close');
            },
            afterCloseResult(isReview) {
                if (!this.isMock) {
                    this.$emit('close-result', this.examData.testID, false, isReview);
                } else {
                    this.$emit('close-result', this.examData.mockTestID, true, isReview);
                }
            }
        },

        beforeDestroy() {
            $(window).off('blur')
            $(document).off('keydown.paper')
        },
    }
</script>

<style lang="scss">
    @import './Paper';

    $rightColor: rgb(92, 178, 40);
    $wrongColor: rgb(213, 51, 51);

    .m-paperExam {

        .paper-avoid-container {
            margin-right: 320px;
            margin-bottom: 30px;
            height: calc(100vh - 160px);
            background-color: #3A3E51;
            color: #fff;

            .avoid-camera {
                display: flex;
                flex-direction: column;
                width: 100%;
                height: 100%;
                justify-content: center;
                align-items: center;

                .title {
                    font-size: 16px;
                    i {
                        margin-right: 6px;
                        font-size: 20px;
                        vertical-align: -2px;
                    }
                }

                .result {
                    margin-top: 20px;
                    padding: 15px 30px;
                    background-color: #4D5162;

                    .error-dot {
                        display: inline-block;
                        margin-right: 6px;
                        width: 8px;
                        height: 8px;
                        background-color: $red;
                        border-radius: 50%;
                    }
                }
            }
        }

        .result-dialog {
            .container {
                padding: 10px 30px;
            }

            .score {
                font-size: 28px;
                text-align: center;
                font-weight: 600;
                color: #019595;
            }

            .result {
                text-align: center;
                img {
                    height: 120px;
                }
                .status {
                    font-size: 15px;
                    font-weight: 600;
                    &.pass {
                        color: $rightColor;
                    }
                    &.unpass {
                        color: $wrongColor;
                    }
                }
            }

            .info-wrap {
                margin-top: 10px;
                padding: 0 30px;

                .info {
                    padding: 7px 0;
                }

                .title {
                    color: #333;
                }

                .content {
                    color: #666;
                }

                .other {
                    color: #999;
                    font-size: 12px;
                }
            }

            .btn-group {
                padding-top: 10px;
                text-align: center;
            }
        }
    }
</style>
